module.exports = __webpack_public_path__ + "static/img/Legendary Eagle.e6616bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Legendary Eagle.png
// module id = PVNW
// module chunks = 35